/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';
import BuyerLoanOfficersBidRequestsRepository from 'repositories/buyer/loanOfficers/BidRequestsRepository';

const initialState = {
  bidRequestCreatingStatus: FETCH_STATUSES.idle,
};

const buyerLoanOfficersBidRequestsSlice = createSlice({
  name: 'buyerLoanOfficersBidRequestsSlice',
  initialState,
  reducers: {
    createBidRequestStart(state) {
      state.bidRequestCreatingStatus = FETCH_STATUSES.pending;
    },
    createBidRequestSuccess(state) {
      state.bidRequestCreatingStatus = FETCH_STATUSES.fulfilled;
    },
    createBidRequestFail(state) {
      state.bidRequestCreatingStatus = FETCH_STATUSES.failed;
    },
  },
});

export const { actions } = buyerLoanOfficersBidRequestsSlice;

export default buyerLoanOfficersBidRequestsSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const createBidRequest = async params => {
    dispatch(actions.createBidRequestStart());
    try {
      await BuyerLoanOfficersBidRequestsRepository.create(params);
      dispatch(actions.createBidRequestSuccess());
    } catch (error) {
      dispatch(actions.createBidRequestFail());
      throw error;
    }
  };

  return {
    createBidRequest,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/buyer/loanOfficers/bidRequestsSlice.js